// extracted by mini-css-extract-plugin
export var actionButton = "_95-1";
export var actionButtons = "_95-2";
export var actions = "_95-0";
export var aiUnread = "_95-10";
export var alignCenter = "_95-h";
export var backWrapper = "_95-3";
export var cellContainer = "_95-4";
export var checkboxContainer = "_95-5";
export var contentContainer = "_95-6";
export var contentHeader = "_95-8";
export var conversationsTableWrapper = "_95-s";
export var draftReplyBadgeContainer = "_95-m";
export var dropdownItem = "_95-b";
export var dropdownItemsContainer = "_95-a";
export var dropdownTitle = "_95-c";
export var errorIcon = "_95-7";
export var filter = "_95-d";
export var gray = "_95-i";
export var headerActionButtons = "_95-e";
export var headerCheckboxContainer = "_95-f";
export var icon = "_95-j";
export var menuContainer = "_95-k";
export var noMoreTicketsIcon = "_95-12";
export var noMoreTicketsSubText = "_95-13";
export var oneLine = "_95-l";
export var optionsButton = "_95-n";
export var plus = "_95-o";
export var portalButtonsWrapper = "_95-g";
export var red = "_95-p";
export var scrolledTop = "_95-9";
export var search = "_95-q";
export var selectedConversationsCount = "_95-r";
export var spinner = "_95-t";
export var strong = "_95-u";
export var summaryCell = "_95-v";
export var tableContainer = "_95-11";
export var tagContainer = "_95-w";
export var threeDots = "_95-x";
export var twoLines = "_95-y";
export var unread = "_95-z";